<template>
  <main id="main-content" class="page page--contact">
    <div class="page__content">
      <Heading title="Contact" hasDivider="true" />
      <p class="page__intro">Thank you for taking the time to view my application.</p>

      <div class="sheet">
        <div class="sheet__twocol">
          <div class="sheet__twocol--left">
            <h2>Nicola Bolton</h2>
            <h3>Hybrid Designer &amp; Developer</h3>
            <p class="mt0 mb2">Location: Vancouver, BC</p>
            <p class="mt0 mb2">Phone: (604) 446 9115</p>
            <p class="mt0 mb2">
              Email:
              <a href="mailto:nicolaebolton@gmail.com">nicolaebolton@gmail.com</a>
            </p>
            <p class="mt0 mb2">
              Portfolio:
              <a href="https://nicolabolton.co" target="_blank">nicolabolton.co</a>
            </p>
          </div>

          <div class="sheet__twocol--right">
            <img src="..//assets/nicola.jpg" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Heading from "@/components/Heading";
export default {
  name: "Contact",
  metaInfo: {
    title: "Contact",
    titleTemplate: "%s | HEY"
  },
  components: {
    Heading
  }
};
</script>
